import {ApiClient} from '@hconnect/apiclient'
import {type ErrorResponse} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {notifyIfErrorMessage} from '../utils'

type CancelMaterialOrderVariables = {plantCode: string; materialOrderId: number}

export const useCancelMaterialOrder = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const raiseError = useErrorHandler()
  const queryClient = useQueryClient()
  return useMutation<void, AxiosError<ErrorResponse>, CancelMaterialOrderVariables>({
    mutationFn: async ({plantCode, materialOrderId}) => {
      await ApiClient.axiosInstance.patch<void>(
        `/plants/${plantCode}/material-orders/${materialOrderId}/cancel`
      )
    },
    mutationKey: ['cancelMaterialOrder'],
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, spawnErrorToast)
    },
    onSuccess: () => {
      spawnSuccessToast(t('success.cancelMaterialOrder'))
    },
    onSettled: () => {
      void queryClient.invalidateQueries({queryKey: ['materialOrders'], refetchType: 'all'})
      void queryClient.invalidateQueries({queryKey: ['stockDevelopment'], refetchType: 'all'})
    }
  })
}
